var BigInteger = require('./bigi')

//addons
require('./convert')

module.exports = BigInteger


//////////////////
// WEBPACK FOOTER
// ./~/bigi/lib/index.js
// module id = 180
// module chunks = 0